import type { TopicStatusTone } from "@/types/content";
import { statusToneClass } from "@/lib/site";

interface StatusTagProps {
  label: string;
  tone: TopicStatusTone;
  size?: "sm" | "md";
}

export default function StatusTag({ label, tone, size = "sm" }: StatusTagProps) {
  const sizeClass = size === "sm" ? "px-2 py-[2px] text-[11px]" : "px-3 py-1 text-xs";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border font-label font-medium tracking-wide whitespace-nowrap ${statusToneClass[tone]} ${sizeClass}`}
    >
      <i
        className={`ri-circle-fill text-[6px] ${tone === "hot" ? "animate-soft-pulse" : ""}`}
        aria-hidden="true"
      />
      {label}
    </span>
  );
}